import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import { TransitionProps } from '@mui/material/transitions';
import Typography from '@mui/material/Typography';
import React from 'react';
import SimpleBar from 'simplebar-react';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction='left' ref={ref} {...props} />;
});

type DialogDetailProps = {
  open: boolean;
  onClose: () => void;
  rowSelect: any;
  handleEditClick: (id: string) => void;
  handleDeleteClick: (id: string) => void;
};

const DialogDetail: React.FC<DialogDetailProps> = (props) => {
  const rowSelect = props.rowSelect || null;
  // const [row, setrow] = useState<any>(null);

  // useEffect(() => {
  //   if (rowSelect && rowSelect.id) {
  //     const token = getToken();
  //     getAPI(`/patient/task-view?id=${rowSelect.id}&token=${token}`)
  //       .then((res) => {
  //         if (res.code === 200) {
  //           setrow(res.data);
  //         }
  //       })
  //       .finally(() => {});
  //   }
  // }, [props.rowSelect.id]);

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      TransitionComponent={Transition}
      sx={{
        position: 'fixed !important',
        top: '0px !important',
        right: '0px !important',
        left: 'auto',
        bottom: 'auto',
        p: '0px',
        // zIndex: 2147483647,
        '& .MuiDialog-paper': {
          m: '0px !important',
          width: '302px',
          height: '100vh',
          bgcolor: '#FAFDFF',
          borderRadius: '16px 0px 0px 16px',
        },
      }}
    >
      <DialogTitle
        id='scroll-dialog-title'
        sx={{ p: '5px 24px 0 24px', mb: '20px' }}
      >
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Stack alignItems={'center'} justifyContent={'center'}>
            <Typography fontWeight={700} color={'#484848'}>
              タスク詳細
            </Typography>
          </Stack>
          <IconButton
            aria-label='close dialog'
            edge='end'
            onClick={props.onClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{
          p: '24px',
          '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
            backgroundColor: '#CCD1D9',
          },
          overflow: 'hidden',
        }}
      >
        <SimpleBar
          style={{ height: 'calc(100vh - 69px)', borderWidth: '18px' }}
        >
          <Stack spacing='15px' height={'calc(100vh - 69px)'}>
            <Stack mb={'10px'}>
              <Typography color={'#00000080'}>
                タスク名
              </Typography>
              <Typography fontWeight={500} color={'#484848'}>
                {(rowSelect && rowSelect.task) || '-'}
              </Typography>
            </Stack>
            <Stack mb={'10px'}>
              <Typography color={'#00000080'}>
                担当者
              </Typography>
              <Typography fontWeight={500} color={'#484848'}>
                {(rowSelect && rowSelect.persons) || '-'}
              </Typography>
            </Stack>
            <Stack mb={'10px'}>
              <Typography color={'#00000080'}>
                名前
              </Typography>
              <Typography fontWeight={500} color={'#484848'}>
                {(rowSelect && rowSelect.patient) || '-'}
              </Typography>
            </Stack>
            <Stack mb={'10px'}>
              <Typography color={'#00000080'}>
                患者履歴
              </Typography>
              <Typography fontWeight={500} color={'#484848'}>
                {(rowSelect && rowSelect.caseid) || '-'}
              </Typography>
            </Stack>
            <Stack mb={'10px'}>
              <Typography color={'#00000080'}>
                期限
              </Typography>
              <Typography fontWeight={500} color={'#484848'}>
                {(rowSelect && rowSelect.deadline) || '-'}
              </Typography>
            </Stack>
            <Stack mb={'10px'}>
              <Typography color={'#00000080'}>
                ステータス
              </Typography>
              <Typography fontWeight={500} color={'#484848'}>
                {(rowSelect && rowSelect.statustext) || '-'}
              </Typography>
            </Stack>
            <Stack mb={'10px'}>
              <Typography color={'#00000080'}>
                備考
              </Typography>
              <Typography fontWeight={500} color={'#484848'}>
                {(rowSelect && rowSelect.note) || '-'}
              </Typography>
            </Stack>
            <Stack mb={'10px'} direction={'row'} spacing={'8px'}>
              <BtnOutlineGradient
                text='変更'
                handleButtonClick={() => props.handleEditClick(rowSelect.id)}
              />
              <BtnOutlineGradient
                text='削除'
                handleButtonClick={() => props.handleDeleteClick(rowSelect.id)}
                grandient='#DA4453'
                color='#DA4453'
              />
            </Stack>
          </Stack>
        </SimpleBar>
      </DialogContent>
    </Dialog>
  );
};

export default DialogDetail;
